// extracted by mini-css-extract-plugin
export default {"container":"MultiSelect_container__miWaT","select":"MultiSelect_select__6-ZvI"};